
import Cookies from 'js-cookie'

function normalizeSetOpts(opt) {
  if (opt == null || typeof opt !== 'object') return undefined
  const o = { ...opt }
  if (o.maxAge != null && o.expires == null) {
    o.expires = new Date(Date.now() + Number(o.maxAge) * 1000)
  }
  delete o.maxAge
  delete o.httpOnly
  const out = {}
  for (const k of ['expires', 'path', 'domain', 'secure', 'sameSite']) {
    if (o[k] !== undefined) out[k] = o[k]
  }
  return Object.keys(out).length ? out : undefined
}

export function load(name, doNotParse) {
  const cookieVal = Cookies.get(name)
  if (typeof cookieVal === 'undefined') return undefined

  if (typeof doNotParse === 'undefined') {
    doNotParse =
      !cookieVal || (cookieVal[0] !== '{' && cookieVal[0] !== '[')
  }

  if (!doNotParse) {
    try {
      return JSON.parse(cookieVal)
    } catch {
      return cookieVal
    }
  }
  return cookieVal
}

export function save(name, val, opt) {
  let v = val
  if (val !== null && typeof val === 'object') v = JSON.stringify(val)
  Cookies.set(name, v, normalizeSetOpts(opt))
}

export function remove(name, opt) {
  let o = {}
  if (typeof opt === 'string') o = { path: opt }
  else if (opt && typeof opt === 'object') o = { ...opt }
  Cookies.remove(name, normalizeSetOpts(o))
}

export default { load, save, remove }
